import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { emptyArray } from 'ui-components/default-props/empty';
import { isGenericPackage } from '../../../services/package-service';

import Global from '../../../store/global-selectors';

export const getPackageIds = (selectedPackages, services, selectedShippingServiceId) => {
  const sanitizePackageId = (packageId) => {
    if (!isGenericPackage(packageId)) {
      return packageId;
    }
    // this sanitization is necessary due to packageTypeId=3 being shared
    //  across all carriers & no service selected.
    const selectedCarrierId = services.find((x) => x.serviceId === selectedShippingServiceId)?.carrierId ?? 0;
    const splitPackageId = packageId.split('-');
    const packageTypeId = splitPackageId[0];
    const isCustom = splitPackageId[1];
    return `${packageTypeId}-${isCustom}-${selectedCarrierId}`;
  };

  if (!selectedPackages?.length) {
    return emptyArray;
  }
  return selectedPackages.filter((pkg) => !!pkg).map((pkg) => sanitizePackageId(pkg.packageId));
};

export const useGetPackageIds = (selectedPackages, selectedShippingServiceId) => {
  const services = useSelector(Global.selectSellerActiveServices);

  const packageIds = useMemo(() => {
    return getPackageIds(selectedPackages, services, selectedShippingServiceId);
  }, [selectedPackages, services, selectedShippingServiceId]);
  return packageIds;
};
